module.exports = __webpack_public_path__ + "img/hospital.d54103d4.png";